import * as cellModule from './SupportLoginCell'
import { useCell } from 'src/lib/cellWrapper'

export default (props) => useCell(cellModule, props)
